"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.personalDetailsValidationRules = void 0;
// Validation rules: https://angieslist.atlassian.net/wiki/display/SE/Data+Validation

var personalDetailsValidationRules = exports.personalDetailsValidationRules = {
  firstName: {
    required: true,
    maxLength: 128,
    title: true
  },
  lastName: {
    required: true,
    maxLength: 128,
    title: true
  },
  'primaryPhoneNumber': {
    required: false,
    phoneNumber: true
  },
  'mobilePhoneNumber': {
    required: false,
    phoneNumber: true
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/account-ion/lib/modules/common/validations/personalDetails.js
// module id = 4253
// module chunks = 9